import { useMemo } from 'react';
import getLang from 'I18n/utils/getLang';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import { useSearchReviewsLegacyQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';
import * as LIST_QUERIES from '../constants/ReviewsListQueries';
import Review from '../records/Review';
export function useSearchReviewsLegacy({
  appContext,
  entityId,
  reviewFilters,
  reviewType,
  skip
}) {
  var _LIST_QUERIES$STATE_T, _LIST_QUERIES$STATE_T2, _sortState$sortFields, _filterState$overallR, _rf$reviewerPortalId, _rf$reviewerUserId;
  const language = getLang();
  const rf = reviewFilters;
  const filterState = (_LIST_QUERIES$STATE_T = LIST_QUERIES.STATE_TO_QUERY[rf.filter]) !== null && _LIST_QUERIES$STATE_T !== void 0 ? _LIST_QUERIES$STATE_T : {};
  const sortState = (_LIST_QUERIES$STATE_T2 = LIST_QUERIES.STATE_TO_QUERY[rf.sort]) !== null && _LIST_QUERIES$STATE_T2 !== void 0 ? _LIST_QUERIES$STATE_T2 : {};
  const offset = (rf.page - 1) * rf.limit;
  const {
    data,
    loading,
    error
  } = useSearchReviewsLegacyQuery({
    variables: Object.assign({
      entityId,
      reviewTypesEnums: [reviewType],
      language,
      limit: rf.limit,
      offset,
      sortFields: (_sortState$sortFields = sortState.sortFields) !== null && _sortState$sortFields !== void 0 ? _sortState$sortFields : [LIST_QUERIES.SORT.NEWEST],
      overallRating: (_filterState$overallR = filterState.overallRating) !== null && _filterState$overallR !== void 0 ? _filterState$overallR : undefined,
      search: rf.search || undefined,
      reviewerPortalId: (_rf$reviewerPortalId = rf.reviewerPortalId) !== null && _rf$reviewerPortalId !== void 0 ? _rf$reviewerPortalId : undefined,
      reviewerUserId: (_rf$reviewerUserId = rf.reviewerUserId) !== null && _rf$reviewerUserId !== void 0 ? _rf$reviewerUserId : undefined
    }, rf.employees ? {
      employeeSizes: {
        clause: 'OR',
        values: [rf.employees]
      }
    } : {}, rf.industry ? {
      industries: {
        clause: 'OR',
        values: [rf.industry]
      }
    } : {}, rf.service ? {
      tagFilters: [{
        group: 'CATALOG_SERVICES',
        values: [rf.service],
        clause: 'OR'
      }]
    } : {}),
    // external auth (chirp-frontend-external) requires a logged-in user; skip for public pages.
    skip: appContext === 'public' || !entityId || skip
  });
  return useMemo(() => {
    var _data$reviews, _data$total;
    return {
      reviews: Review.fromArray(((_data$reviews = data === null || data === void 0 ? void 0 : data.reviews) !== null && _data$reviews !== void 0 ? _data$reviews : []).map(r => {
        var _legacyReviewId;
        return Object.assign({}, r, {
          // legacyReviewId is the v1 review ID; use it over the default id
          // field once the BE adds it to LegacyReviewResponse.
          id: (_legacyReviewId = r.legacyReviewId) !== null && _legacyReviewId !== void 0 ? _legacyReviewId : r.id
        });
      }), reviewType),
      reviewsFetchStatus: getDataFetchingClientRequestState(error, loading),
      reviewsTotal: (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0
    };
  }, [data, error, loading, reviewType]);
}